import React, { useState, useRef, useEffect, useContext } from "react"; 
import "./Downloads.css";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Container, Col, Row, Table } from "react-bootstrap";  
import pdf7 from "../../pdf/dummy.pdf"; 
import pdficon from "../../Images/downloadpdf.png";
import URLstateContext from "../../provider/CommonContext";
import { MdClose } from "react-icons/md";
import Assamese from "../../UploadDownloads/Assamese.zip";
import Bengali from "../../UploadDownloads/Bengali.zip";
import Gujrati from "../../UploadDownloads/Gujrati.zip";
import Hindi from "../../UploadDownloads/Hindi.zip";
import Kanada from "../../UploadDownloads/Kanada.zip";
import Kashmiri from "../../UploadDownloads/kashmiri.zip";
import Konkani from "../../UploadDownloads/konkani.zip";
import Marathi from "../../UploadDownloads/Marathi.zip";
import Oriya from "../../UploadDownloads/Oriya.zip";
import Punjabi from "../../UploadDownloads/Punjabi.zip";
import Sindhi from "../../UploadDownloads/Sindhi.zip";
import Tamil from "../../UploadDownloads/Tamil.zip";
import Telegu from "../../UploadDownloads/Telegu.zip";
import Urdu from "../../UploadDownloads/Urdu.zip";

import MCX_assamese from "../../UploadDownloads/MCX_assamese.zip";
import MCX_bengalie from "../../UploadDownloads/MCX_bengalie.zip";
import MCX_gujarati from "../../UploadDownloads/MCX_gujarati.zip";
import MCX_hindi from "../../UploadDownloads/MCX_hindi.zip";
import MCX_kannada from "../../UploadDownloads/MCX_kannada.zip";
import MCX_kashmiri from "../../UploadDownloads/MCX_kashmiri.zip";
import MCX_konkani from "../../UploadDownloads/MCX_konkani.zip";
import MCX_malayalam from "../../UploadDownloads/MCX_malayalam.zip";
import MCX_marathi from "../../UploadDownloads/MCX_marathi.zip";
import MCX_oriya from "../../UploadDownloads/MCX_oriya.zip";
import MCX_punjabi from "../../UploadDownloads/MCX_punjabi.zip";
import MCX_sindhi from "../../UploadDownloads/MCX_sindhi.zip";
import MCX_tamil from "../../UploadDownloads/MCX_tamil.zip";
import MCX_telegu from "../../UploadDownloads/MCX_telegu.zip";
import MCX_urdu from "../../UploadDownloads/MCX_urdu.zip";
 import CallTrackApi from '../Activity_Track/CallTrackApi';

import { format } from 'date-fns';
function Downloads() {
    const { BaseLiveURL } = useContext(URLstateContext);
    //const refElement = useRef("");
    const [data, setData] = useState(false);
    const [ismonthly, setismonthly] = useState(false);
    const [section, setsection] = useState(false);
    const [nodatafound, setnodatafound] = useState(false);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const downloadsclick = (section,sectionid) => {
        setsection(section);
        postData('api/Login/Downloads', { sectionid: sectionid })
            .then((data) => {
               
                if (data.data != null && data.data.length > 0) { setnodatafound(false);setData(data.data); }
                else { setData(null); setnodatafound(true);}
                
            });
    }
    useEffect(() => {
        setsection("DP Forms");
        postData('api/Login/Downloads', { sectionid: "1" })
            .then((data) => {
                
                if (data.data != null && data.data.length > 0) { setnodatafound(false); setData(data.data); }
                else { setData(null); setnodatafound(true); }
            });
    }, []);
    async function postData(url = '', data = {}) {
         
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }
    const clickLanguage = () => {
        setShow1(true);
    }
    const clickLanguages = () => {
        setShow2(true);
    }
    const handleClose1 = () => setShow1(false);
    const handleClose2 = () => setShow2(false);
    CallTrackApi("Downloads",window.location.href);
    return (
        <>
            <section className="our-story-block disclaimer">
                <Container>
                    <Row>
                        <Col md={{ span: 12, offset: 0 }}>
                            <div className="our-story-inner investor-charter">
                                <h2>Downloads</h2>
                                <ul>
                                    <li>
                                        <a   className={section === "DP Forms" ? "downloadbtnactive" : "cursorclass"} onClick={() => downloadsclick('DP Forms',1)}>
                                           DP Forms
                                        </a>
                                    </li>
                                    <li>
                                        <a className={section === "Mutual Fund Forms" ? "downloadbtnactive" : "cursorclass"}  onClick={() => downloadsclick('Mutual Fund Forms',2)}>
                                            Mutual Fund Forms
                                        </a>
                                    </li>
                                    <li>
                                        <a className={section === "ODIN" ? "downloadbtnactive" : "cursorclass"} onClick={() => downloadsclick('ODIN',3)}>
                                            ODIN
                                        </a>
                                    </li>
                                    <li>
                                        <a className={section === "Pleadgeable Securities" ? "downloadbtnactive" : "cursorclass"} onClick={() => downloadsclick('Pleadgeable Securities',4)} >
                                            Pleadgeable Securities
                                        </a>
                                    </li>
                                    <li>
                                        <a className={section === "Policy documents" ? "downloadbtnactive" : "cursorclass"} onClick={() => downloadsclick('Policy documents',5)} >
                                            Policy documents
                                        </a>
                                    </li>
                                    <li>
                                        <a className={section === "Softwares" ? "downloadbtnactive" : "cursorclass"} onClick={() => downloadsclick('Softwares',6)} >
                                            Softwares
                                        </a>
                                    </li>
                                    <li>
                                        <a className={section === "Vernacular Language" ? "downloadbtnactive" : "cursorclass"} onClick={() => clickLanguage()} >
                                            Vernacular Language (Equity)
                                        </a>
                                    </li>
                                    <li>
                                        <a className={section === "Vernacular Language" ? "downloadbtnactive" : "cursorclass"} onClick={() => clickLanguages()} >
                                            Vernacular Language (Commodity)
                                        </a>
                                    </li>
                                </ul>
                                 <Table bordered>

                                    <thead>
                                        <tr>
                                            {/* <td className="headingtext"> Date
                                            </td> */}
                                            <td className="headingtext">
                                                Caption
                                            </td>
                                            <td className="headingtext textcenter">
                                                Download File
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                        {data &&
                                            data.map(
                                            ({ upddate, caption, uploadfile }) => (
                                                    <tr>
                                                     
                                                        <td>{caption}</td>
                                                        <td>
                                                        <a href={BaseLiveURL+ "pdf/" +uploadfile} download>
                                                                <img className="imgwidth" src={pdficon} alt="pdf icon" />
                                                            </a>    
                                                        </td>
                                                    </tr>
                                                 )
                                            )}
                                        {nodatafound &&
                                            <tr>
                                            <td colSpan="3" className="textcenter nodata">No {section} found !!!</td>
                                            </tr>
                                            }
                                      
                                    </tbody>
                                </Table>
                                
                            </div>
                            <Modal show={show1} onHide={handleClose1} className="tool-modal whytradeus_popup">
                                <Button variant="secondary" onClick={handleClose1} className="btn-close text-right">
                                    <MdClose />
                                </Button>
                                <Modal.Body>
                                    <div className='tool-col'>
                                        <div className='headcontent'>
                                           Download Client Registration Documents 
                                        </div>
                                       
                                    </div>
                                    <div>
                                        <div className='datacontent'>
                                            Download Client Registration Documents (Rights & Obligations, Risk Disclosure Document, Do's & Don't's) in Vernacular Language :
                                        </div>
                                    </div>
                                    <div className="langtext">
                                        <a href={Assamese} className="" target="_blank">Assamese</a>
                                        <a href={Bengali} target="_blank">Bengali
                                        </a><a href={Gujrati} target="_blank">Gujarati
                                        </a><a href={Hindi} target="_blank">Hindi</a><a href={Kanada}  target="_blank">Kanada
                                        </a><a href={Kashmiri} target="_blank">Kashmiri</a><a href={Konkani} target="_blank">Konkani
                                            </a>
                                        <a href="#">Malyalam</a><a href={Marathi} target="_blank">Marathi
                                                </a><a href={Oriya} target="_blank">Oriya
                                                </a><a href={Punjabi} target="_blank">Punjabi</a><a href={Sindhi} target="_blank">Sindhi</a><a href={Tamil} target="_blank">Tamil
                                                    </a><a href={Telegu} target="_blank">Telegu
                                                    </a><a href={Urdu} target="_blank">Urdu
                                                    </a>
                                                            
                                    </div>
                                    <div>
                                    <div className='datacontent'>
                                         NOTE : " This document is a translated version of the client registration documents in English and is being provided in vernacular language to facilitate better understanding by the investors. In case of any ambiguity, the contents of the English version would prevail. "
                                    </div>
                                    </div>
                                </Modal.Body>
                            </Modal>

                            <Modal show={show2} onHide={handleClose2} className="tool-modal whytradeus_popup">
                                <Button variant="secondary" onClick={handleClose2} className="btn-close text-right">
                                    <MdClose />
                                </Button>
                                <Modal.Body>
                                    <div className='tool-col'>
                                        <div className='headcontent'>
                                           Download Client Registration Documents 
                                        </div>
                                       
                                    </div>
                                    <div>
                                        <div className='datacontent'>
                                            Download Client Registration Documents (Rights & Obligations, Risk Disclosure Document, Do's & Don't's) in Vernacular Language :
                                        </div>
                                    </div>
                                    <div className="langtext">
                                       <a href={MCX_assamese} className="">Assamese</a>
                                        
                                        <a href={MCX_bengalie}>Bengali  
                                        </a><a href={MCX_gujarati}>Gujarati
                                        </a><a href={MCX_hindi}>Hindi</a><a href={MCX_kannada}>Kanada
                                        </a><a href={MCX_kashmiri}>Kashmiri</a><a href={MCX_konkani}>Konkani
                                            </a>
                                        <a href={MCX_malayalam}>Malyalam</a><a href={MCX_marathi}>Marathi
                                                </a><a href={MCX_oriya}>Oriya
                                                </a><a href={MCX_punjabi}>Punjabi</a><a href={MCX_sindhi}>Sindhi</a><a href={MCX_tamil}>Tamil
                                                    </a><a href={MCX_telegu}>Telegu
                                                    </a><a href={MCX_urdu}>Urdu
                                                    </a>
                                                            
                                    </div>
                                    <div>
                                    <div className='datacontent'>
                                         NOTE : " This document is a translated version of the client registration documents in English and is being provided in vernacular language to facilitate better understanding by the investors. In case of any ambiguity, the contents of the English version would prevail. "
                                    </div>
                                    </div>
                                </Modal.Body>
                            </Modal>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}
export default Downloads;
